/* eslint-disable jsx-a11y/anchor-is-valid */
import { GoAAppHeader, GoAAppHeaderMenu } from "@abgov/react-components";
import styles from "./HeaderBar.module.scss";
import { useNavigate } from "react-router-dom";
export interface IHeaderBarLink {
    label: string;
    path: string;
    isDefault?: boolean;
    external?: boolean;
    newTab?: boolean;
    permissions?: string[];
}
interface IHeaderBarProps {
    links?: IHeaderBarLink[];
    logoUrl: string;
    headerTitle: string;
    profileName?: string;
    isAuthenticated?: boolean;
    onSignout?: () => void;
}
const { navbar, tab, current } = styles;
const HeaderBar: React.FC<IHeaderBarProps> = ({
    links,
    logoUrl,
    headerTitle,
    profileName,
    onSignout,
    isAuthenticated,
}) => {
    const navigate = useNavigate();

    const isCurrent = (link: IHeaderBarLink) => {
        let currentPath = window.location.pathname;
        if (link.external) {
            currentPath = window.location.origin;
        }

        return (
            currentPath.includes(link.path) ||
            (link.isDefault ? currentPath === "/" : false)
        );
    };

    return (
        <GoAAppHeader
            url={logoUrl}
            heading={headerTitle}
            maxContentWidth="100%"
        >
            <div className={navbar}>
                {links &&
                    links.map((x, index) => {
                        const isActive = isCurrent(x);
                        const classes = `${tab} ${isActive ? current : ""}`;

                        return x.external ? (
                            <a
                                key={index}
                                href={x.path}
                                className={classes}
                                {...(x.newTab
                                    ? {
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                      }
                                    : {})}
                            >
                                {x.label}
                            </a>
                        ) : (
                            <div
                                key={index}
                                className={classes}
                                onClick={() => navigate(x.path)}
                            >
                                {x.label}
                            </div>
                        );
                    })}
            </div>
            {isAuthenticated && (
                <GoAAppHeaderMenu
                    heading={profileName ?? ""}
                    leadingIcon="person-circle"
                >
                    <a onClick={onSignout}>Sign out</a>
                </GoAAppHeaderMenu>
            )}
        </GoAAppHeader>
    );
};

export default HeaderBar;
